import type { ComponentProps } from 'react';

export const LogoutIcon = (props:ComponentProps<'svg'>) => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M23.4668 40.5333C23.4668 46.5673 23.4668 49.5843 25.3413 51.4588C27.2158 53.3333 30.2328 53.3333 36.2668 53.3333H38.4001C44.4341 53.3333 47.4511 53.3333 49.3256 51.4588C51.2001 49.5843 51.2001 46.5673 51.2001 40.5333V23.4667C51.2001 17.4327 51.2001 14.4157 49.3256 12.5412C47.4511 10.6667 44.4341 10.6667 38.4001 10.6667H36.2668C30.2328 10.6667 27.2158 10.6667 25.3413 12.5412C23.4668 14.4157 23.4668 17.4327 23.4668 23.4667"
      stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path
      d="M23.4665 48C18.4382 48 15.924 48 14.3619 46.4379C12.7998 44.8758 12.7998 42.3616 12.7998 37.3333V26.6667C12.7998 21.6384 12.7998 19.1242 14.3619 17.5621C15.924 16 18.4382 16 23.4665 16"
      stroke="currentColor" strokeWidth="3" />
    <path d="M19.1999 32L38.3999 32M38.3999 32L33.0666 37.3333M38.3999 32L33.0666 26.6667" stroke="currentColor"
          strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)